import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {OrganizationData } from "../../types/allorganization";
import { getOrganizationById, getOrganizationsByContactId, getOrgTypeById } from "../thunks/organizationThunks";
import { OrgTypeResponse } from "../../types/orgType";

interface OrganizationState {
  organization: OrganizationData | null;
  organizations: OrganizationData[];
  orgTypes:OrgTypeResponse[],
  orgType:OrgTypeResponse,
  loading: boolean;
  error: string | null;
  success: string | null;
}

const initialState: OrganizationState = {
  organization: null,
  organizations:[],
  orgTypes:[],
  orgType: null,
  loading: false,
  error: null,
  success: null,
};

export const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    // optional manual setters if you still want to update state directly
    setOrganization: (state, action:PayloadAction<OrganizationData>) => {
      state.organization = action.payload;
    },
    setOrgTypes: (state, action:PayloadAction<OrgTypeResponse[]>) => {
      state.orgTypes = action.payload;
    },
    setOrgType: (state, action:PayloadAction<OrgTypeResponse>) => {
      state.orgType = action.payload;
    },
    setError: (state, action:PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizationById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(getOrganizationById.fulfilled, (state, action) => {
        state.loading = false;
        state.organization = action.payload.Data; // ✅ because API returns RootObjectOrganization with `.Data`
        state.success = "Organization loaded successfully";
      })
      .addCase(getOrganizationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

        .addCase(getOrganizationsByContactId.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(getOrganizationsByContactId.fulfilled, (state, action) => {
        state.loading = false;
        state.organizations = action.payload.Data; // ✅ because API returns RootObjectOrganization with `.Data`
        state.success = "Organization loaded successfully";
      })
      .addCase(getOrganizationsByContactId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getOrgTypeById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(getOrgTypeById.fulfilled, (state, action) => {
        state.loading = false;
        state.orgType = action.payload; // ✅ because API returns RootObjectOrganization with `.Data`
        state.success = "OrgType loaded successfully";
      })
      .addCase(getOrgTypeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});

export const { setOrganization, setError } = organizationSlice.actions;

export default organizationSlice.reducer;
